import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ErrorModel } from '@rocksoft/shared';
import { AllowedOsUpdate } from './allowed-os-updates.state';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AllowedOsUpdatesResolverActions = createActionGroup({
  source: 'Device OS Updates resolver',
  events: {
    'Allowed updates requested': props<{ deviceId: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const OsUpdatesApiActions = createActionGroup({
  source: 'OS Updates API',
  events: {
    'Device allowed updates loaded': props<{ updates: AllowedOsUpdate[] }>(),
    'Device allowed updates error': props<{ error: ErrorModel }>(),
    'Device updated': emptyProps(),
    'Device updated error': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// VIEW ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CurrentDeviceViewActions = createActionGroup({
  source: 'Current device view',
  events: {
    'Update to latest allowed version': props<{ deviceId: string }>(),
  },
});
